'use client';

import { useId } from 'react';

import classnames from 'classnames';

import type { SwitchCheckProps } from './SwitchCheck.types';

import styles from './SwitchCheck.module.scss';

function SwitchCheck({
  style,
  className,
  checked = false,
  disabled = false,
  error = false,
  labelPosition = 'right',
  label,
  onChange,
  testId = 'ui-switch-check',
}: SwitchCheckProps) {
  const labelId = useId();

  const labelElement = (
    <div
      id={labelId}
      className={classnames(
        styles['label'],
        disabled && styles['label--disabled'],
        error && styles['label--error'],
        labelPosition && styles[`label--${labelPosition}`],
        className,
      )}
    >
      {label}
    </div>
  );

  return (
    <div
      style={style}
      className={classnames(styles['switch-check'], className)}
      data-testid={testId}
    >
      {label && labelPosition === 'left' && labelElement}
      <label className={styles['check']}>
        <input
          type="checkbox"
          className={styles['input']}
          value={checked ? 'checked' : 'unchecked'}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          aria-labelledby={label ? labelId : undefined}
        />
        <div className={styles['slider']} />
      </label>
      {label && labelPosition === 'right' && labelElement}
    </div>
  );
}

export { SwitchCheck };
